/**
 * Amberden — the further photographs open Horizon's zoom (2026-09-14).
 *
 * blocks/amberden-extras.liquid renders the Gallery list below the split on
 * product page C, while the gallery beside the lane shows only the pair. The
 * zoom dialog still carries the whole list, pair first, so photograph n in this
 * block is index n (1-based in the markup, because the pair is index 0).
 *
 * Delegated on document so it survives the block being morphed on a finish
 * change. Horizon's media-gallery exposes zoom(index, event).
 */
(function () {
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target.closest('[data-amb-zoom]') : null;
    if (!target) return;
    var section = target.closest('.shopify-section');
    var gallery = section && section.querySelector('media-gallery');
    if (!gallery || typeof gallery.zoom !== 'function') return;
    var index = parseInt(target.getAttribute('data-amb-zoom'), 10);
    if (isNaN(index)) return;
    event.preventDefault();
    gallery.zoom(index, event);
  });
})();
